import { render, staticRenderFns } from "./RemoveModal.vue?vue&type=template&id=ba420b7c&"
import script from "./RemoveModal.vue?vue&type=script&lang=js&"
export * from "./RemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports